import { Button, Input, List, Modal, Popconfirm, Space, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import type { FestivalCalcStore } from "../store";

interface Props {
  store: FestivalCalcStore;
}

export const SnapshotManager = observer(({ store }: Props) => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [saving, setSaving] = useState(false);

  async function handleSave() {
    if (!title.trim()) return;
    setSaving(true);
    try {
      await store.saveSnapshot(title.trim());
      setTitle("");
    } finally {
      setSaving(false);
    }
  }

  return (
    <>
      <Button onClick={() => setOpen(true)}>Versionen</Button>
      <Modal
        open={open}
        title="Kalkulations-Versionen"
        onCancel={() => setOpen(false)}
        footer={null}
        width={520}
      >
        <Space.Compact style={{ width: "100%", marginBottom: 16 }}>
          <Input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Versionsname (z.B. Optimistisch v1)"
            onPressEnter={handleSave}
          />
          <Button type="primary" onClick={handleSave} loading={saving} disabled={!title.trim()}>
            Speichern
          </Button>
        </Space.Compact>

        <List
          dataSource={store.snapshots}
          locale={{ emptyText: "Noch keine Versionen gespeichert" }}
          renderItem={(snap) => (
            <List.Item
              actions={[
                <Popconfirm
                  key="del"
                  title="Version löschen?"
                  onConfirm={() => snap.objectId && store.deleteSnapshot(snap.objectId)}
                  okText="Löschen"
                  cancelText="Abbrechen"
                >
                  <Button type="text" danger size="small">✖</Button>
                </Popconfirm>,
              ]}
            >
              <List.Item.Meta
                title={snap.title}
                description={
                  <Typography.Text type="secondary" style={{ fontSize: 11 }}>
                    {snap.createdAt?.toLocaleString("de-DE")}
                    {snap.createdBy && ` · ${(snap.createdBy as any).get?.("username") ?? ""}`}
                  </Typography.Text>
                }
              />
            </List.Item>
          )}
        />
      </Modal>
    </>
  );
});
